// import React, { useEffect, useState } from "react";
// import { BiArrowBack } from "react-icons/bi";
// import { useNavigate, useParams } from "react-router-dom";
// import axios from "axios";

// const EditCollegeNotes = () => {
//   const [universities, setUniversities] = useState([]);
//   const [universityId, setUniversityId] = useState("");
//   const [courses, setCourses] = useState([]);
//   const [courseId, setCourseId] = useState("");
//   const [semesters, setSemesters] = useState([]);
//   const [semesterId, setSemesterId] = useState("");
//   const [universitySubjects, setUniversitySubjects] = useState([]);
//   const [universitySubjectId, setUniversitySubjectId] = useState("");
//   const [noteTitle, setNoteTitle] = useState("");
//   const [file, setFile] = useState(null);
//   const [language, setLanguage] = useState("");
//   const [loading, setLoading] = useState(true); // Add loading state

//   const { id } = useParams(); // Assuming ID is passed via route params
//   const navigate = useNavigate();
//   const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

//   // Fetch existing note data and set initial form values
//   useEffect(() => {
//     axios
//       .get(`${API_BASE_URL}/notes/${id}`)
//       .then((response) => {
//         const noteData = response.data?.data;
//         console.log(noteData);

//         setUniversityId(noteData.universityId);
//         setCourseId(noteData.courseId);
//         setSemesterId(noteData.semesterId);
//         setUniversitySubjectId(noteData.universitySubjectId);
//         setNoteTitle(noteData.noteTitle);
//         setLanguage(noteData.language);
//         setLoading(false); // Mark loading as complete
//       })
//       .catch((error) => {
//         console.error("Error fetching note data:", error);
//         setLoading(false);
//       });
//   }, [id, API_BASE_URL]);

//   // Fetch universities, courses, semesters, and subjects data
//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const [universityRes, semesterRes] = await Promise.all([
//           axios.get(`${API_BASE_URL}/universities`),
//           axios.get(`${API_BASE_URL}/semesters`),
//         ]);
//         setUniversities(universityRes.data.data || []);
//         setSemesters(semesterRes.data.data || []);
//       } catch (error) {
//         console.log(error);
//       }
//     };
//     fetchData();
//   }, [API_BASE_URL]);

//   useEffect(() => {
//     if (universityId) {
//       axios
//         .get(`${API_BASE_URL}/all-courses/${universityId}`)
//         .then((response) => setCourses(response.data.data || []))
//         .catch((error) => console.log(error));
//     }
//   }, [API_BASE_URL, universityId]);

//   useEffect(() => {
//     if (courseId && semesterId) {
//       axios
//         .get(
//           `${API_BASE_URL}/college-subjects?courseId=${courseId}&semesterId=${semesterId}`
//         )
//         .then((response) => setUniversitySubjects(response.data.data || []))
//         .catch((error) => console.log(error));
//     }
//   }, [API_BASE_URL, courseId, semesterId]);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const formData = new FormData();
//     formData.append("universityId", universityId);
//     formData.append("courseId", courseId);
//     formData.append("semesterId", semesterId);
//     formData.append("universitySubjectId", universitySubjectId);
//     formData.append("noteTitle", noteTitle);
//     formData.append("language", language);
//     if (file) formData.append("file", file);

//     axios
//       .put(`${API_BASE_URL}/admin/notes/${id}`, formData, {
//         headers: {
//           "Content-Type": "multipart/form-data",
//           Authorization: `Bearer ${localStorage.getItem("token")}`,
//         },
//       })
//       .then(() => {
//         alert("Note updated successfully");
//         navigate("/upload-notes/upload-all-university-notes");
//       })
//       .catch((error) => console.error("Error updating note:", error));
//   };

//   const handleGoBack = () => {
//     navigate("/upload-notes/upload-all-notes");
//   };
//   const handleAddNewNote = () => {
//     navigate("/upload-notes/upload-add-university-notes");
//   };

//   const handleViewAllNotes = () => {
//     navigate("/upload-notes/upload-all-university-notes");
//   };

//   if (loading) {
//     return <div>Loading...</div>; // Show loading state while data is being fetched
//   }

//   return (
//     <div id="exam-school-notes-inner-wrapper">
//       <div className="main-header">
//         <BiArrowBack
//           onClick={handleGoBack}
//           className="left-arrow-icon"
//           style={{ cursor: "pointer", fontSize: "25px", color: "#000" }}
//         />
//         <div className="allcollegenotes-header-div">
//           <h5>All College Notes</h5>

//           <div className="allcollegenotes-header-btns">
//             <button className="add-college-note-btn" onClick={handleAddNewNote}>
//               + Upload Notes
//             </button>
//             <button
//               className="all-college-notes-btn"
//               onClick={handleViewAllNotes}
//             >
//               All Notes
//             </button>
//           </div>
//         </div>
//         <h5> Edit College Notes</h5>
//       </div>
//       <div className="form-container " id="form">
//         <form onSubmit={handleSubmit} className="note-detail-form">
//           <div className="input-group">
//             <label className="label">Note Title</label>
//             <input
//               type="text"
//               value={noteTitle}
//               onChange={(e) => setNoteTitle(e.target.value)}
//               required
//             />
//           </div>
//           <div className="input-group">
//             <label className="label">Language</label>
//             <input
//               type="radio"
//               value="hindi"
//               checked={language === "hindi"}
//               onChange={(e) => setLanguage(e.target.value)}
//             />{" "}
//             Hindi
//             <input
//               type="radio"
//               value="english"
//               checked={language === "english"}
//               onChange={(e) => setLanguage(e.target.value)}
//             />{" "}
//             English
//           </div>
//           <div className="input-group">
//             <label className="label">Upload File (PDF)</label>
//             <input
//               type="file"
//               onChange={(e) => setFile(e.target.files[0])}
//               accept=".pdf"
//             />
//           </div>
//           <button type="submit" className="btn-save">
//             Update
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default EditCollegeNotes;













import React, { useEffect, useState } from "react";
import { BiArrowBack } from "react-icons/bi";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";

const EditCollegeNotes = () => {
  const [universities, setUniversities] = useState([]);
  const [universityId, setUniversityId] = useState("");
  const [courses, setCourses] = useState([]);
  const [courseId, setCourseId] = useState("");
  const [semesters, setSemesters] = useState([]);
  const [semesterId, setSemesterId] = useState("");
  const [universitySubjects, setUniversitySubjects] = useState([]);
  const [universitySubjectId, setUniversitySubjectId] = useState("");
  const [noteTitle, setNoteTitle] = useState("");
  const [file, setFile] = useState(null);
  const [language, setLanguage] = useState("");

  // ✅ ADDED: videoUrl state
  const [videoUrl, setVideoUrl] = useState("");

  const [loading, setLoading] = useState(true); // Add loading state

  const { id } = useParams(); // Assuming ID is passed via route params
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

  // Fetch existing note data and set initial form values
  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/notes/${id}`)
      .then((response) => {
        const noteData = response.data?.data;
        console.log(noteData);

        setUniversityId(noteData.universityId);
        setCourseId(noteData.courseId);
        setSemesterId(noteData.semesterId);
        setUniversitySubjectId(noteData.universitySubjectId);
        setNoteTitle(noteData.noteTitle);
        setLanguage(noteData.language);

        // ✅ ADDED: set existing videoUrl
        setVideoUrl(noteData.videoUrl || "");

        setLoading(false); // Mark loading as complete
      })
      .catch((error) => {
        console.error("Error fetching note data:", error);
        setLoading(false);
      });
  }, [id, API_BASE_URL]);

  // Fetch universities, courses, semesters, and subjects data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [universityRes, semesterRes] = await Promise.all([
          axios.get(`${API_BASE_URL}/universities`),
          axios.get(`${API_BASE_URL}/semesters`),
        ]);
        setUniversities(universityRes.data.data || []);
        setSemesters(semesterRes.data.data || []);
      } catch (error) {
        console.log(error);
      }
    };
    fetchData();
  }, [API_BASE_URL]);

  useEffect(() => {
    if (universityId) {
      axios
        .get(`${API_BASE_URL}/all-courses/${universityId}`)
        .then((response) => setCourses(response.data.data || []))
        .catch((error) => console.log(error));
    }
  }, [API_BASE_URL, universityId]);

  useEffect(() => {
    if (courseId && semesterId) {
      axios
        .get(
          `${API_BASE_URL}/college-subjects?courseId=${courseId}&semesterId=${semesterId}`
        )
        .then((response) => setUniversitySubjects(response.data.data || []))
        .catch((error) => console.log(error));
    }
  }, [API_BASE_URL, courseId, semesterId]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("universityId", universityId);
    formData.append("courseId", courseId);
    formData.append("semesterId", semesterId);
    formData.append("universitySubjectId", universitySubjectId);
    formData.append("noteTitle", noteTitle);
    formData.append("language", language);

    // ✅ ADDED: include videoUrl in update
    formData.append("videoUrl", videoUrl);

    if (file) formData.append("file", file);


    const role = localStorage.getItem("role");
    // decide endpoint based on role
    const endpoint =
      role === "subAdmin"
        ? `${API_BASE_URL}/subadmin/notes/${id}`
        : `${API_BASE_URL}/admin/notes/${id}`;

    axios
      .put(endpoint, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then(() => {
        alert("Note updated successfully");
        navigate("/upload-notes/upload-all-university-notes");
      })
      .catch((error) => console.error("Error updating note:", error));
  };

  const handleGoBack = () => {
    navigate("/upload-notes/upload-all-notes");
  };
  const handleAddNewNote = () => {
    navigate("/upload-notes/upload-add-university-notes");
  };

  const handleViewAllNotes = () => {
    navigate("/upload-notes/upload-all-university-notes");
  };

  if (loading) {
    return <div>Loading...</div>; // Show loading state while data is being fetched
  }

  return (
    <div id="exam-school-notes-inner-wrapper">
      <div className="main-header">
        <BiArrowBack
          onClick={handleGoBack}
          className="left-arrow-icon"
          style={{ cursor: "pointer", fontSize: "25px", color: "#000" }}
        />
        <div className="allcollegenotes-header-div">
          <h5>All College Notes</h5>

          <div className="allcollegenotes-header-btns">
            <button className="add-college-note-btn" onClick={handleAddNewNote}>
              + Upload Notes
            </button>
            <button
              className="all-college-notes-btn"
              onClick={handleViewAllNotes}
            >
              All Notes
            </button>
          </div>
        </div>
        <h5> Edit College Notes</h5>
      </div>

      <div className="form-container " id="form">
        <form onSubmit={handleSubmit} className="note-detail-form">
          <div className="input-group">
            <label className="label">Note Title</label>
            <input
              type="text"
              value={noteTitle}
              onChange={(e) => setNoteTitle(e.target.value)}
              required
            />
          </div>

          {/* ✅ ADDED: Video URL input */}
          <div className="input-group">
            <label className="label">Video URL</label>
            <input
              type="text"
              value={videoUrl}
              onChange={(e) => setVideoUrl(e.target.value)}
              placeholder="https://youtube.com/watch?v=..."
            />
            {!!videoUrl && (
              <small style={{ display: "block", marginTop: 6 }}>
                <a href={videoUrl} target="_blank" rel="noreferrer">
                  Preview Video
                </a>
              </small>
            )}
          </div>

          <div className="input-group">
            <label className="label">Language</label>
            <input
              type="radio"
              value="hindi"
              checked={language === "hindi"}
              onChange={(e) => setLanguage(e.target.value)}
            />{" "}
            Hindi
            <input
              type="radio"
              value="english"
              checked={language === "english"}
              onChange={(e) => setLanguage(e.target.value)}
            />{" "}
            English
          </div>

          <div className="input-group">
            <label className="label">Upload File (PDF)</label>
            <input
              type="file"
              onChange={(e) => setFile(e.target.files[0])}
              accept=".pdf"
            />
          </div>

          <button type="submit" className="btn-save">
            Update
          </button>
        </form>
      </div>
    </div>
  );
};

export default EditCollegeNotes;